import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useListPreview = () =>
  useStore(store => store.buildList.state)
